import { render, staticRenderFns } from "./SitchFontPreview.vue?vue&type=template&id=464056b0&scoped=true&"
import script from "./SitchFontPreview.vue?vue&type=script&lang=ts&"
export * from "./SitchFontPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SitchFontPreview.vue?vue&type=style&index=0&id=464056b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464056b0",
  null
  
)

export default component.exports